import React from 'react';

const SUPPORT_EMAIL = 'support@toolboxforweb.xyz';

const styles = {
  footer: { marginTop: 'auto', padding: '18px', textAlign: 'center', borderTop: '1px solid #e5e7eb', color: '#6b7280', fontSize: '13px' },
  link: { color: '#1a73e8', textDecoration: 'none' },
};

export function Footer({ strings }) {
  const subject = encodeURIComponent(strings.contactSupportSubject);
  const href = `mailto:${SUPPORT_EMAIL}?subject=${subject}`;

  return (
    <footer style={styles.footer}>
      <a href={href} style={styles.link}>{strings.contactSupport}</a>
    </footer>
  );
}
